import * as React from 'react'

import Layout from '../components/layout'
import Head from '../components/head'

const IndexPage = () => {
  return (
    <Layout>
      <div>
        <main>
          <Head title="Vita" />

          <div className="">
            <div className="flex">
              <div className="w-48 pb-6">
                <div className="mb-1 text-xl font-serif">1950</div>
                <span>Berlin</span>
              </div>
              <div className="pt-1 pb-4 pl-5">geboren in Berlin</div>
            </div>

            <div className="flex">
              <div className="w-48 pt-5 pb-6">
                <div className="mb-1 text-xl font-serif">1970-1974</div>
                <span>Berlin</span>
              </div>
              <div className="pt-6 pb-4 pl-5">
                Studium Staatliche Hochschule für bildende Künste<br />
                Abteilung V - Fachrichtung Bühnenkostüm<br />
                Diplomabschluss
              </div>
            </div>

            <div className="flex">
              <div className="w-48 pt-5 pb-6">
                <div className="mb-1 text-xl font-serif">1974 - heute</div>
                <span>Berlin</span>
              </div>
              <div className="pt-6 pb-4 pl-5">
                Nach Abschluss tätig als Kostümbildnerin bei Theater und Film
              </div>
            </div>
          </div>
        </main>
      </div>
    </Layout>
  )
}

export default IndexPage
